module.exports = __webpack_public_path__ + "static/media/pickup.31964c7a.svg";